import { Card, Typography, useTheme } from "@mui/material";
import { useHistory } from "react-router-dom";

const ItemCard = ({ id, item }: any) => {
  const history = useHistory();

  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  const cardStyles = {
    borderRadius: "16px",
    padding: "24px 8px",
    width: "120px",
    height: "120px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    textAlign: "center",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#1976D214",
    },
  };

  const handleCardClick = () => {
    if (item.target) {
      item.target === "_blank"
        ? window.open(item.path, "_blank")
        : (window.location.href = item.path);
    } else {
      history.push(item.path);
    }
  };

  return (
    <Card
      id={`${id}-key-${item.id}`}
      key={item.id}
      sx={cardStyles}
      onClick={handleCardClick}
      elevation={1}
    >
      <div style={{ width: "36px", height: "36px" }}>{item.icon}</div>
      <Typography variant="h6">{item.title}</Typography>
    </Card>
  );
};

export default ItemCard;
